import Button from '@mui/material/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { trackActivity } from '../utils/custom-track-events';
import { CertificateTrackAction, TrackCategory } from '@pok/activity-metric-sdk';
import LinkedinShortIcon from './icons/LinkedinShortIcon.jsx';
import { linkedinOrganizationId } from '../interact.jsx';
import { useLoading } from '@pok/weblib/context/loading-context.jsx';

export default function LinkedinProfileButton({ disabled, cert, onSendEvent, organization }) {
    const { t } = useTranslation();
    const certDate = new Date(cert.date);
    const { showLoading, hideLoading } = useLoading();
    const openLink = (e) => {
        let link = e.currentTarget.dataset.link;
        const target = e.currentTarget.dataset.linkTarget;
        showLoading();
        linkedinOrganizationId(cert)
            .then((id) => {
                window.open(link.concat(id ? `&organizationId=${id}` : ''), target);
            })
            .finally(() => hideLoading());

        const linkMethod = e.currentTarget.dataset.linkMethod;
        onSendEvent(linkMethod);
        trackActivity(
            TrackCategory.CERTIFICATE,
            CertificateTrackAction.ADD_TO_LINKEDIN_PROFILE,
            cert.id,
            cert.minter,
        ).then();
    };

    return (
        <Button
            data-link={'https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME'
                .concat('&organizationName=')
                .concat(encodeURIComponent(cert.institution ? cert.institution : organization?.name))
                .concat('&name=')
                .concat(encodeURIComponent(cert.title))
                .concat('&certUrl=')
                .concat(encodeURIComponent(cert.url))
                .concat('&certId=')
                .concat(encodeURIComponent(cert.tokenId ?? cert.id))
                .concat('&issueYear=')
                .concat(certDate.getFullYear().toString())
                .concat('&issueMonth=')
                .concat((certDate.getMonth() + 1).toString())}
            data-link-target={'_blank'}
            data-link-method="linkedin-profile"
            variant="contained"
            sx={{
                fontWeight: '600',
                width: '100%',
                fontSize: { xs: 12, md: 14 },
                borderColor: '#2867B2',
                padding: '12px',
                borderRadius: '8px',
                background: '#2867B2',
                '&:disabled': { borderColor: '#F6F6F6', background: '#F6F6F6 !important' },
            }}
            onClick={openLink}
            disabled={disabled}
            startIcon={<LinkedinShortIcon fill={disabled ? '#CCC9D1' : '#FFF'} />}
        >
            {t('certificate.share.linkedin-profile')}
        </Button>
    );
}
